/**
 * The authenticated `/portal/v1` client. See stores/session.ts for why the
 * token lives outside Pinia.
 */
import { createApiClient } from '@fcms/ui'
import { clearSession, sessionToken } from '@/stores/session'
import router from '@/router'

export const api = createApiClient({
  baseUrl: '/portal/v1',
  getToken: () => sessionToken.value,
  onUnauthorized: () => {
    // The portal issues a 30-day bearer token with no refresh mechanism (see
    // internal/auth's portalSessionTTL) — there is nothing to repair, so a
    // 401 always means "sign in again". Clearing the session here (rather
    // than only redirecting) means every other open tab's next request also
    // sees no token and fails fast instead of retrying against a dead one.
    clearSession()
    if (router.currentRoute.value.name !== 'login') {
      router.push({ name: 'login', query: { redirect: router.currentRoute.value.fullPath } })
    }
    return false
  },
  timeoutMs: 15_000,
})
